"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPostcodesInAreaAreasPostcodesGetRequest$ = exports.GetPostcodesInAreaAreasPostcodesGetRequest$outboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetRequest$inboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetSecurity$ = exports.GetPostcodesInAreaAreasPostcodesGetSecurity$outboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetSecurity$inboundSchema = void 0;
exports.getPostcodesInAreaAreasPostcodesGetSecurityToJSON = getPostcodesInAreaAreasPostcodesGetSecurityToJSON;
exports.getPostcodesInAreaAreasPostcodesGetSecurityFromJSON = getPostcodesInAreaAreasPostcodesGetSecurityFromJSON;
exports.getPostcodesInAreaAreasPostcodesGetRequestToJSON = getPostcodesInAreaAreasPostcodesGetRequestToJSON;
exports.getPostcodesInAreaAreasPostcodesGetRequestFromJSON = getPostcodesInAreaAreasPostcodesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPostcodesInAreaAreasPostcodesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPostcodesInAreaAreasPostcodesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodesInAreaAreasPostcodesGetSecurity$;
(function (GetPostcodesInAreaAreasPostcodesGetSecurity$) {
    /** @deprecated use `GetPostcodesInAreaAreasPostcodesGetSecurity$inboundSchema` instead. */
    GetPostcodesInAreaAreasPostcodesGetSecurity$.inboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetSecurity$inboundSchema;
    /** @deprecated use `GetPostcodesInAreaAreasPostcodesGetSecurity$outboundSchema` instead. */
    GetPostcodesInAreaAreasPostcodesGetSecurity$.outboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetSecurity$outboundSchema;
})(GetPostcodesInAreaAreasPostcodesGetSecurity$ || (exports.GetPostcodesInAreaAreasPostcodesGetSecurity$ = GetPostcodesInAreaAreasPostcodesGetSecurity$ = {}));
function getPostcodesInAreaAreasPostcodesGetSecurityToJSON(getPostcodesInAreaAreasPostcodesGetSecurity) {
    return JSON.stringify(exports.GetPostcodesInAreaAreasPostcodesGetSecurity$outboundSchema.parse(getPostcodesInAreaAreasPostcodesGetSecurity));
}
function getPostcodesInAreaAreasPostcodesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodesInAreaAreasPostcodesGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPostcodesInAreaAreasPostcodesGetSecurity' from JSON`);
}
/** @internal */
exports.GetPostcodesInAreaAreasPostcodesGetRequest$inboundSchema = z.object({
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
});
/** @internal */
exports.GetPostcodesInAreaAreasPostcodesGetRequest$outboundSchema = z.object({
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodesInAreaAreasPostcodesGetRequest$;
(function (GetPostcodesInAreaAreasPostcodesGetRequest$) {
    /** @deprecated use `GetPostcodesInAreaAreasPostcodesGetRequest$inboundSchema` instead. */
    GetPostcodesInAreaAreasPostcodesGetRequest$.inboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetRequest$inboundSchema;
    /** @deprecated use `GetPostcodesInAreaAreasPostcodesGetRequest$outboundSchema` instead. */
    GetPostcodesInAreaAreasPostcodesGetRequest$.outboundSchema = exports.GetPostcodesInAreaAreasPostcodesGetRequest$outboundSchema;
})(GetPostcodesInAreaAreasPostcodesGetRequest$ || (exports.GetPostcodesInAreaAreasPostcodesGetRequest$ = GetPostcodesInAreaAreasPostcodesGetRequest$ = {}));
function getPostcodesInAreaAreasPostcodesGetRequestToJSON(getPostcodesInAreaAreasPostcodesGetRequest) {
    return JSON.stringify(exports.GetPostcodesInAreaAreasPostcodesGetRequest$outboundSchema.parse(getPostcodesInAreaAreasPostcodesGetRequest));
}
function getPostcodesInAreaAreasPostcodesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodesInAreaAreasPostcodesGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPostcodesInAreaAreasPostcodesGetRequest' from JSON`);
}
//# sourceMappingURL=getpostcodesinareaareaspostcodesget.js.map